
            <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)"
             size="large"
             color="white"
             loadingText="Loading please wait..."
             type="ball-clip-rotate-multiple"></ngx-spinner>
<router-outlet></router-outlet>
